export default __webpack_public_path__ + "static/media/security-scan.e92be822.svg";